import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { ProjetsComponent } from './projets.component';
import { ProjetComponent } from './projet.component';

const routes: Routes = [
  {
    path: '',
    component: ProjetsComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component: ProjetComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProjetsRoutingModule { }

export const routedComponents = [
  ProjetsComponent,
  ProjetComponent
];
